module.exports = __webpack_public_path__ + "static/media/Plain-Medium.79b7c5a8.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Plain-Medium.ttf
// module id = 1001
// module chunks = 0 1 2 3 4 5 6 7